/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAudienceFromJSON, ApiAudienceToJSON, } from './ApiAudience';
import { ApiContactFromJSON, ApiContactToJSON, } from './ApiContact';
import { ApiDataFromJSON, ApiDataToJSON, } from './ApiData';
import { ApiLeadConversionFromJSON, ApiLeadConversionToJSON, } from './ApiLeadConversion';
import { ApiLeadLinkFromJSON, ApiLeadLinkToJSON, } from './ApiLeadLink';
import { ApiLeadProcessStatusFromJSON, ApiLeadProcessStatusToJSON, } from './ApiLeadProcessStatus';
import { ApiLeadScoreFromJSON, ApiLeadScoreToJSON, } from './ApiLeadScore';
import { ApiLeadStatusFromJSON, ApiLeadStatusToJSON, } from './ApiLeadStatus';
import { ApiPredictionFromJSON, ApiPredictionToJSON, } from './ApiPrediction';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiRetentionFromJSON, ApiRetentionToJSON, } from './ApiRetention';
import { ApiSaleFromJSON, ApiSaleToJSON, } from './ApiSale';
import { ApiSessionFromJSON, ApiSessionToJSON, } from './ApiSession';
import { ApiStaticAudienceFromJSON, ApiStaticAudienceToJSON, } from './ApiStaticAudience';
import { ApiStaticClassificationFromJSON, ApiStaticClassificationToJSON, } from './ApiStaticClassification';
export function ApiLeadFromJSON(json) {
    return ApiLeadFromJSONTyped(json, false);
}
export function ApiLeadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'analyticsSynced': !exists(json, 'analyticsSynced') ? undefined : json['analyticsSynced'],
        'anonymous': !exists(json, 'anonymous') ? undefined : json['anonymous'],
        'audiences': !exists(json, 'audiences') ? undefined : (json['audiences'].map(ApiAudienceFromJSON)),
        'contact': !exists(json, 'contact') ? undefined : ApiContactFromJSON(json['contact']),
        'contactId': !exists(json, 'contactId') ? undefined : json['contactId'],
        'conversions': !exists(json, 'conversions') ? undefined : (json['conversions'].map(ApiLeadConversionFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'data': !exists(json, 'data') ? undefined : (json['data'].map(ApiDataFromJSON)),
        'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
        'fbp': !exists(json, 'fbp') ? undefined : json['fbp'],
        'firstCaptured': !exists(json, 'firstCaptured') ? undefined : json['firstCaptured'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'lastActivityAt': !exists(json, 'lastActivityAt') ? undefined : (new Date(json['lastActivityAt'])),
        'leadLinks': !exists(json, 'leadLinks') ? undefined : (json['leadLinks'].map(ApiLeadLinkFromJSON)),
        'predictions': !exists(json, 'predictions') ? undefined : (json['predictions'].map(ApiPredictionFromJSON)),
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'retentions': !exists(json, 'retentions') ? undefined : (json['retentions'].map(ApiRetentionFromJSON)),
        'sales': !exists(json, 'sales') ? undefined : (json['sales'].map(ApiSaleFromJSON)),
        'scores': !exists(json, 'scores') ? undefined : (json['scores'].map(ApiLeadScoreFromJSON)),
        'sessions': !exists(json, 'sessions') ? undefined : (json['sessions'].map(ApiSessionFromJSON)),
        'staticAudiences': !exists(json, 'staticAudiences') ? undefined : (json['staticAudiences'].map(ApiStaticAudienceFromJSON)),
        'staticClassifications': !exists(json, 'staticClassifications') ? undefined : (json['staticClassifications'].map(ApiStaticClassificationFromJSON)),
        'status': !exists(json, 'status') ? undefined : ApiLeadProcessStatusFromJSON(json['status']),
        'statuses': !exists(json, 'statuses') ? undefined : (json['statuses'].map(ApiLeadStatusFromJSON)),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiLeadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'analyticsSynced': value.analyticsSynced,
        'anonymous': value.anonymous,
        'audiences': value.audiences === undefined ? undefined : (value.audiences.map(ApiAudienceToJSON)),
        'contact': ApiContactToJSON(value.contact),
        'contactId': value.contactId,
        'conversions': value.conversions === undefined ? undefined : (value.conversions.map(ApiLeadConversionToJSON)),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'data': value.data === undefined ? undefined : (value.data.map(ApiDataToJSON)),
        'externalId': value.externalId,
        'fbp': value.fbp,
        'firstCaptured': value.firstCaptured,
        'id': value.id,
        'key': value.key,
        'lastActivityAt': value.lastActivityAt === undefined ? undefined : (value.lastActivityAt.toISOString()),
        'leadLinks': value.leadLinks === undefined ? undefined : (value.leadLinks.map(ApiLeadLinkToJSON)),
        'predictions': value.predictions === undefined ? undefined : (value.predictions.map(ApiPredictionToJSON)),
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'retentions': value.retentions === undefined ? undefined : (value.retentions.map(ApiRetentionToJSON)),
        'sales': value.sales === undefined ? undefined : (value.sales.map(ApiSaleToJSON)),
        'scores': value.scores === undefined ? undefined : (value.scores.map(ApiLeadScoreToJSON)),
        'sessions': value.sessions === undefined ? undefined : (value.sessions.map(ApiSessionToJSON)),
        'staticAudiences': value.staticAudiences === undefined ? undefined : (value.staticAudiences.map(ApiStaticAudienceToJSON)),
        'staticClassifications': value.staticClassifications === undefined ? undefined : (value.staticClassifications.map(ApiStaticClassificationToJSON)),
        'status': ApiLeadProcessStatusToJSON(value.status),
        'statuses': value.statuses === undefined ? undefined : (value.statuses.map(ApiLeadStatusToJSON)),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
